/**
 * @fileoverview Root application component for the React application.
 * @description This file defines the top-level App component, which serves as the root of the
 * component tree rendered by the application. It delegates all composition — the TanStack Query
 * client and the router — to AppProviders, keeping this file trivial. AppProviders is wrapped in
 * LocationGate, which asks for location once, as the app first loads.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import AppProviders from '@/app/providers/AppProviders'
import LocationGate from '@/app/providers/LocationGate'
import { useDisableRightClick } from '@/shared/hooks/useDisableRightClick'

/**
 * @component
 * @description Root component rendered by main.tsx. Applies app-wide startup concerns (currently
 * just the right-click blocker) before delegating all real composition to AppProviders, wrapped in
 * LocationGate.
 */
function App() {
  useDisableRightClick()

  return (
    <LocationGate>
      <AppProviders />
    </LocationGate>
  )
}

export default App
